export default __webpack_public_path__ + "static/media/runnerup_1.24372b64.jpg";